import { Injectable } from '@angular/core';
import { LogService } from '@innovation-os-ng/core/logger';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private storage: Storage;

  constructor(private readonly logger: LogService) {
    try {
      this.storage = window.localStorage;
    } catch (error) {
      this.logger.info('localstorage not available');
    }
  }

  public get(key: string, fallback: string = ''): string {
    try {
      return this.storage.getItem(key);
    } catch (error) {
      return fallback;
    }
  }

  public set(key: string, value: string): boolean {
    try {
      this.storage.setItem(key, value);
      return true;
    } catch (errror) {
      return false;
    }
  }
}
